import { useState, useEffect } from 'react';
import { LANDING_PAGE_CONFIG } from '../constants';

export function useLandingPageConfig() {
  const [config, setConfig] = useState(null);
  const [isExpired, setIsExpired] = useState(null);

  useEffect(() => {
    const configStr = localStorage.getItem(LANDING_PAGE_CONFIG);
    if (configStr) {
      const { data, expiryTime } = JSON.parse(configStr);
      const now = new Date().getTime();
      setIsExpired(now > expiryTime);
      if (now < expiryTime) {
        setConfig(data);
      } else {
        localStorage.removeItem(LANDING_PAGE_CONFIG);
      }
    }
    setIsExpired(true);
  }, []);

  const getExpiredTime = new Date().getTime() + 2 * 60 * 60 * 1000;

  const setLandingPageConfig = (data) => {
    const expiryTime = new Date().getTime() + getExpiredTime;
    localStorage.setItem(
      LANDING_PAGE_CONFIG,
      JSON.stringify({ data, expiryTime })
    );
    setConfig(data);
  };

  return { config, setLandingPageConfig, isExpired };
}
